import { Card, EmptyState as UiEmptyState } from '@dreamtree-org/twreact-ui';

/** twreact-ui EmptyState in a card: title, one line on what to do (children), optional action. */
export default function EmptyState({ title, children, action, icon, compact }) {
  return (
    <Card>
      <UiEmptyState title={title} description={children} action={action} icon={icon} compact={compact} />
    </Card>
  );
}
